var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProfileIcon = function SvgProfileIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17 0C7.611 0 0 7.611 0 17s7.611 17 17 17 17-7.611 17-17S26.389 0 17 0m0 7.364a4.76 4.76 0 0 1 4.76 4.686 4.76 4.76 0 1 1-9.52 0A4.76 4.76 0 0 1 17 7.364m8.65 18.36a1.7 1.7 0 0 1-1.36.755H9.785a1.63 1.63 0 0 1-1.4-.755 1.71 1.71 0 0 1-.15-1.59 9.52 9.52 0 0 1 17.605 0c.178.52.108 1.094-.19 1.556z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProfileIcon);
export default ForwardRef;